import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.div`
  position: absolute;
  font-family: "SpoqaHanSansNeoRegular";
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  background: ${(props) => `${props.theme.colors.white}`};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
`;

const H5 = styled.h5`
  font-weight: 400;
  font-size: 32px;
  line-height: 52px;
  text-align: center;
  color: ${(props) => `${props.theme.colors.black}`};
`;

const H4 = styled.h4`
  font-weight: 700;
  font-size: 32px;
  font-style: normal;
  line-height: 52px;
  text-align: center;
  color: ${(props) => `${props.theme.colors.orange}`};
`;

const Button = styled.button`
  width: 184px;
  height: 56px;
  border: none;
  border-radius: 40px;
  background-color: ${(props) => `${props.theme.colors.orange}`};
  color: ${(props) => `${props.theme.colors.white}`};
  font-size: 18px;
  line-height: 28px;
  font-weight: bold;
`;

export default function Start() {
  return (
    <Container>
      <div>
        <H5>어르신 돌보미</H5>
        <H4>케어코디</H4>
      </div>
      <Link to="care-type-selection">
        <Button>신청하기</Button>
      </Link>
    </Container>
  );
}
